import s from "./Hr.module.scss";

const Hr = () => <hr className={s.hr} />;

export default Hr;
